// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39e52923","581":"96338dda"}[chunkId] + ".chunk.js";
};